/**
 * Derive the cookie domain from a hostname: the registrable parent (last two
 * labels) rather than assuming a `.com` TLD, so non-.com local dev domains work
 * too — gradebook.mynhadev.com -> mynhadev.com, gradebook.mynhadev.local ->
 * mynhadev.local. Pure so it can be unit tested without stubbing `window`.
 */
export const parseAppDomain = (hostname: string): string => {
	const hostParts: string[] = hostname.split('.');
	if (hostParts.length > 2) {
		return hostParts.slice(-2).join('.');
	}
	return hostname;
};

// Use hostname (never host) so the port is excluded — cookie domains can't contain one.
export const getAppDomain = (): string => parseAppDomain(window.location.hostname);
